import type { SVGProps } from 'react'
const SvgSyWalletAlt = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800" width={24} height={24} {...props}>
		<path
			fillOpacity={0.2}
			d="M100 333.3c0-94.3 0-141.4 29.3-170.7s76.4-29.3 170.7-29.3h200c94.3 0 141.4 0 170.7 29.3S700 239 700 333.3V390c0 4.7 0 7.1-1.5 8.5-1.5 1.5-3.8 1.5-8.5 1.5H550c-15.5 0-23.2 0-29.7 1.3-26.4 5.3-47.1 25.9-52.4 52.4-1.3 6.4-1.3 14.2-1.3 29.7s0 23.2 1.3 29.7c5.3 26.4 25.9 47.1 52.4 52.4 6.4 1.3 14.2 1.3 29.7 1.3h145.2c2.6 0 4.8 2.1 4.8 4.8 0 52.6-42.6 95.2-95.2 95.2H300c-94.3 0-141.4 0-170.7-29.3S100 561.1 100 466.8V333.5z"
		/>
		<path d="M466.7 466.7c0-36.8 29.8-66.7 66.7-66.7h161.7c2.8 0 5 2.2 5 5v156.7c0 2.8-2.2 5-5 5H533.4c-36.8 0-66.7-29.8-66.7-66.7zm-250-233.4h166.7c9.2 0 16.7 7.5 16.7 16.7s-7.5 16.7-16.7 16.7H216.7c-9.2 0-16.7-7.5-16.7-16.7s7.5-16.7 16.7-16.7" />
	</svg>
)
export default SvgSyWalletAlt
